import type { Card } from '@/hooks/useCards'
import { isAuctionListing } from '@/lib/games'
import {Tag} from 'lucide-react'

interface ListingGridTileProps {
  card: Card
  onOpen?: () => void
}

function ListingGridTile({ card, onOpen }: ListingGridTileProps) {
  const auction = isAuctionListing(card.saleType)
  const showPrice = !auction && card.forSale !== false && card.price != null

  return (
    <button
      type="button"
      onClick={onOpen}
      className="group relative aspect-square overflow-hidden bg-[#111111] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FFDE00]"
    >
      {card.imageUrl ? (
        <img
          src={card.imageUrl}
          alt={card.title}
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center text-white/20">
          <Tag className="h-8 w-8" />
        </div>
      )}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-90" />
      {auction ? (
        <span className="absolute bottom-2 left-2 rounded-full bg-[#FF1A1A] px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-white shadow-[0_2px_0_#9d1010]">
          Auction
        </span>
      ) : showPrice ? (
        <span className="absolute bottom-2 left-2 rounded-full bg-[#FFDE00] px-2 py-0.5 text-[10px] font-extrabold text-black shadow-[0_2px_0_#c9a800]">
          ${Number(card.price).toFixed(2)}
        </span>
      ) : null}
    </button>
  )
}

export default ListingGridTile
